import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { updateAttribute } from '../../../../services/dtServices'
import { IAttribute } from '../../interfaces'

export const useUpdateAttribute = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof updateAttribute>>,
    Error,
    IAttribute
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (attribute: IAttribute) => {
            return updateAttribute(orgId, entityId, attribute.uid, {
                ...attribute,
                isSearchable: true,
            })
        },
        //client side optimistic update
        onMutate: (newAttribute: IAttribute) => {
            queryClient.setQueryData(
                ['attributes', entityId, orgId],
                (prevAttributes: IAttribute[]) =>
                    prevAttributes?.map((prevAttribute: IAttribute) =>
                        prevAttribute.uid === newAttribute.uid
                            ? newAttribute
                            : prevAttribute,
                    ),
            )
        },
        //refetch attributes after mutation,
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['attributes', entityId, orgId],
            }),
    })
}
